<template>
  <div class="listContainer">
    <!-- No Team Dialog -->
    <el-dialog
      :visible.sync="noTeamDialogVisible"
      width="460px"
      :close-on-click-modal="false"
      custom-class="entry-diagnostic-dialog list-team-dialog"
      :append-to-body="true"
    >
      <div class="list-team-dialog__body">
        <header class="list-team-dialog__header">
          <span>ENTRY BLOCKED</span>
          <h2>Team Not Found</h2>
          <p>No team information found for this exam.</p>
        </header>
        <div class="list-team-dialog__content">
          <p style="word-break: normal; overflow-wrap: break-word; font-size: 14px; line-height: 1.6; margin: 0;">
            No team information found. Please contact your advisor to set up your team.
          </p>
          <report-problem-button
            :context="noTeamContext"
            :template-name="noTeamTemplateName"
          />
        </div>
        <footer class="list-team-dialog__actions">
          <el-button type="primary" @click="noTeamDialogVisible = false">OK</el-button>
        </footer>
      </div>
    </el-dialog>

    <quick-message-drawer
      :visible.sync="quickMessageVisible"
      :student-id="user_id"
      :project-code="project_code"
      :snapshot="listMessageSnapshot"
    />

    <exam-entry-diagnostic-dialog
      :visible.sync="showEntryDiagnostic"
      :diagnostic="entryDiagnostic"
    />
    <div v-if="event_rooms.length === 0 && loaded" class="emptyState">
      <img src="../../../assets/am-logo.png" class="emptyLogo" />
      <div class="emptyText">No events available at the moment.</div>
    </div>
    <div class="listToolbar">
      <el-button
        size="small"
        icon="el-icon-chat-dot-square"
        class="messagesToolbarBtn"
        @click="quickMessageVisible = true"
      >Messages</el-button>
    </div>
    <div v-for="(item, index) in event_rooms" :key="index" class="eventItem">
      <img
        :src="getBannerImage(item.event_name)"
        class="eventImg"
      />
      <div class="left" :class="{ 'has-mock-warning': isMockTest(item) }">
        <div
          class="itemTitle"
          :style="{ color: getEventColor(item.event_name) }"
        >
          {{ item.school_day_title || item.project_ename }}
        </div>
        <div
          class="itemName"
          :style="{ color: getEventColor(item.event_name) }"
        >
          {{ item.event_name }}
        </div>
        <div class="eventTime">
          <div class="eventTimeContainer">
            <div v-if="item.exam_info" class="eventTimeItem">
              Test Opens (UTC) : {{ formateTime(item.exam_info.exam_begin_time) }}
            </div>
          </div>
        </div>
        <div
          v-if="isMockTest(item)"
          class="mockWarning"
          role="note"
        >
          Failure to complete the Mock Test will result in a 3-point deduction.
        </div>
      </div>
      <div class="right">
        <div
          v-if="item.exam_info"
          class="eventStatusContainer"
          :style="{ background: getEntryStateColor(item) }"
        >
          <div
            class="outContent"
            v-if="item.entry_state && item.entry_state.code === 'countdown'"
          >
            <div class="txt">Test Countdown</div>
            <div
              class="time"
              :style="{ color: getEventColor(item.event_name) }"
            >
              {{
                item.exam_info.countDownTimes
                  ? item.exam_info.countDownTimes
                  : getFormatDuringTime(0)
              }}
            </div>
          </div>
          <button
            v-else-if="item.entry_state"
            type="button"
            class="toContent"
            :class="{ 'is-disabled': item.entry_state.action === 'none' }"
            :disabled="item.entry_state.action === 'none'"
            @click="handleListEntryAction(item)"
          >
            <span>{{ item.entry_state.label }}</span>
            <small v-if="item.entry_state.detail">{{ item.entry_state.detail }}</small>
          </button>
        </div>
      </div>
    </div>
    <exam-entry-diagnostic-dialog
      :visible.sync="showEntryDiagnostic"
      :diagnostic="entryDiagnostic"
    />
  </div>
</template>

<script>
import {
  getExamRooms,
  checkIsUploadTest,
  checkUserInvigilate,
  getExamProctoringPolicy,
  getRelayTeamMembers,
  getExamEntryDiagnostics,
  claimExamIpBinding,
  getUser,
} from "../../../api/index";
import {
  getUserId,
  getUserName,
  getAccountName,
  getProjectCode,
  getProjectEname,
  resolveAndSetExamProjectCode,
  setTestEvent,
} from "../../../utils/store";
import {
  MAX_EXAM_CLOCK_SKEW_MS,
  measureExamClock,
  buildClockErrorMessage,
} from "../../../utils/server-time";
import ExamEntryDiagnosticDialog from "./ExamEntryDiagnosticDialog.vue";
import QuickMessageDrawer from "../../Support/QuickMessageDrawer.vue";
import ReportProblemButton from "../../Support/ReportProblemButton.vue";
export default {
  components: {
    ExamEntryDiagnosticDialog,
    QuickMessageDrawer,
    ReportProblemButton,
  },
  data() {
    return {
      project_code: getProjectCode(),
      project_ename: getProjectEname(),
      event_rooms: [],
      loaded: false,
      colorMap: {
        Mock: "#11448D",
        Artithon: "#11448D",
        Biothon: "#246EB3",
        Chemithon: "#445CB4",
        Econthon: "#E3A948",
        Geothon: "rgb(4,52,124)",
        Historithon: "rgb(171,9,61)",
        Mathethon: "rgb(9,54,80)",
        Physithon: "rgb(53,110,174)",
        Psychothon: "rgb(111,183,217)",
      },
      user_id: getUserId(),
      noTeamDialogVisible: false,
      noTeamContext: null,
      noTeamTemplateName: "",
      quickMessageVisible: false,
      individualSubmitRefreshTimer: null,
      entryLoading: null,
      showEntryDiagnostic: false,
      entryDiagnostic: null,
      identityConfirmationOpen: false,
    };
  },
  computed: {
    listMessageSnapshot() {
      return {
        page: "list",
        project_code: this.project_code,
      };
    },
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    this.closeEntryLoading();
    if (this.individualSubmitRefreshTimer) {
      window.clearTimeout(this.individualSubmitRefreshTimer);
      this.individualSubmitRefreshTimer = null;
    }
    this.event_rooms.forEach((item) => {
      if (item.exam_info && item.exam_info.countDownThread) {
        window.clearInterval(item.exam_info.countDownThread);
      }
    });
  },
  methods: {
    fetchData() {
      getExamRooms(getUserId(), "AM").then((res) => {
        if (res.data.code === 0) {
          this.event_rooms = res.data.data.map((item) => {
            item.entry_state = this.buildListEntryState(item);
            if (item.exam_info && item.exam_info.status.status === "还未开始") {
              this.handleRestTime(item);
            }
            return item;
          });
          if (this.event_rooms.some(item => this.isIndividualFinalizing(item))) {
            if (this.individualSubmitRefreshTimer) {
              window.clearTimeout(this.individualSubmitRefreshTimer);
            }
            this.individualSubmitRefreshTimer = window.setTimeout(() => this.fetchData(), 3000);
          }
        }
        this.loaded = true;
      });
    },

    async goExam(item) {
      const identityConfirmed = await this.confirmExamIdentity();
      if (!identityConfirmed) return;

      var startTime = item.exam_info.exam_begin_time;
      var temp1 = parseInt(startTime) * 1000;
      var test_event = item.event_name;
      var exam_type = item.exam_info.exam_type;
      var exam_mode = this.getExamMode(item);

      var endTime = parseInt(item.exam_info.exam_end_time) * 1000;
      this.entryLoading = this.$loading({
        lock: true,
        text: "Checking exam entry requirements...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });

      let clockResult = null;
      try {
        clockResult = await measureExamClock();
      } catch (error) {
        console.error("Unable to verify the exam server time", error);
      }

      var template_id = item.template_id;
      if (!template_id) {
        this.showEntryBlocked(item, "TEMPLATE_UNAVAILABLE", clockResult, null);
        return;
      }

      let diagnostics = null;
      try {
        const response = await getExamEntryDiagnostics(
          getUserId(),
          getUserId(),
          template_id,
          item.project_code || getProjectCode(),
          { timeout: 12000, skipNetworkErrorMessage: true }
        );
        if (!response.data || response.data.code !== 0 || !response.data.data) {
          throw new Error(
            response.data && response.data.msg
              ? response.data.msg
              : "Exam diagnostic record unavailable"
          );
        }
        diagnostics = response.data.data;
      } catch (error) {
        console.error("Unable to load exam entry diagnostics", error);
        this.showEntryBlocked(item, "ENTRY_CHECK_FAILED", clockResult, null);
        return;
      }

      if (!clockResult && Number(diagnostics.server_time_ms) > 0) {
        const clientTimeMs = Date.now();
        const serverTimeMs = Number(diagnostics.server_time_ms);
        const clockSkewMs = clientTimeMs - serverTimeMs;
        clockResult = {
          valid: Math.abs(clockSkewMs) <= MAX_EXAM_CLOCK_SKEW_MS,
          clockSkewMs,
          serverTimeMs,
          clientTimeMs,
          roundTripMs: null,
        };
      }
      if (!clockResult) {
        this.showEntryBlocked(item, "SERVER_TIME_UNAVAILABLE", null, diagnostics);
        return;
      }
      if (!clockResult.valid) {
        this.showEntryBlocked(item, "CLOCK_MISMATCH", clockResult, diagnostics);
        return;
      }

      const individualState = exam_mode === 'individual'
        ? (diagnostics.individual_exam || item.individual_exam || null)
        : null;
      const individualReentry = Boolean(individualState && individualState.entry_allowed);
      const currentTime = clockResult.serverTimeMs;
      if (currentTime < temp1) {
        this.showEntryBlocked(item, "NOT_STARTED", clockResult, diagnostics);
        return;
      }
      if (currentTime > endTime && !individualReentry) {
        this.showEntryBlocked(item, "ENTRY_CLOSED", clockResult, diagnostics);
        return;
      }

      if (diagnostics.submission && diagnostics.submission.has_submitted) {
        this.showEntryBlocked(item, "ALREADY_SUBMITTED", clockResult, diagnostics);
        return;
      }
      const personalWindowEnd = this.getPersonalWindowEnd(diagnostics.sign, individualState);
      if (personalWindowEnd && currentTime > personalWindowEnd * 1000) {
        this.showEntryBlocked(item, "PERSONAL_WINDOW_EXPIRED", clockResult, diagnostics);
        return;
      }
      if (exam_mode === 'individual' && individualState
        && ['completed', 'expired'].indexOf(individualState.status) !== -1) {
        this.showEntryBlocked(
          item,
          individualState.status === 'expired' ? "PERSONAL_WINDOW_EXPIRED" : "ALREADY_SUBMITTED",
          clockResult,
          diagnostics
        );
        return;
      }
      this.doCheck(template_id, temp1, exam_type, test_event, exam_mode, item, clockResult, diagnostics);
    },
    async confirmExamIdentity() {
      if (this.identityConfirmationOpen) return false;
      this.identityConfirmationOpen = true;
      try {
        const identity = await this.resolveExamIdentity();
        if (!identity.candidateName || !identity.email) {
          await this.$alert(
            "Your candidate name or account email could not be verified. Sign in again or contact support before entering the exam.",
            "Candidate identity unavailable",
            {
              confirmButtonText: "Return",
              type: "warning",
              showClose: false,
              closeOnClickModal: false,
              customClass: "exam-identity-confirm",
            }
          );
          return false;
        }

        const h = this.$createElement;
        const message = h("div", { class: "exam-identity-confirm__content" }, [
          h("p", { class: "exam-identity-confirm__intro" }, "Verify that the candidate details below belong to the person who will take this exam."),
          h("div", { class: "exam-identity-confirm__details" }, [
            h("div", { class: "exam-identity-confirm__row" }, [
              h("span", { class: "exam-identity-confirm__label" }, "Candidate"),
              h("strong", { class: "exam-identity-confirm__name" }, identity.candidateName),
            ]),
            h("div", { class: "exam-identity-confirm__row" }, [
              h("span", { class: "exam-identity-confirm__label" }, "Account"),
              h("span", { class: "exam-identity-confirm__account" }, identity.email),
            ]),
          ]),
          h("p", { class: "exam-identity-confirm__statement" }, "By continuing, you confirm that this is your own account and that you are the registered candidate."),
          h("p", { class: "exam-identity-confirm__help" }, "If these details are incorrect, choose They are not mine and contact support. Do not enter the exam."),
        ]);
        await this.$confirm(message, "Confirm candidate identity", {
          confirmButtonText: "These details are mine",
          cancelButtonText: "They are not mine",
          type: "warning",
          showClose: false,
          closeOnClickModal: false,
          customClass: "exam-identity-confirm",
        });
        return true;
      } catch (error) {
        return false;
      } finally {
        this.identityConfirmationOpen = false;
      }
    },
    async resolveExamIdentity() {
      const normalize = (value) => {
        const text = String(value || "").trim();
        return ["undefined", "null"].indexOf(text.toLowerCase()) === -1 ? text : "";
      };
      let candidateName = normalize(getUserName());
      let email = normalize(getAccountName());
      if (candidateName && email) return { candidateName, email };
      try {
        const response = await getUser(
          getUserId(),
          "student",
          getProjectCode(),
          { timeout: 12000, skipNetworkErrorMessage: true }
        );
        const user = response && response.data && response.data.code === 0
          ? response.data.data || {}
          : {};
        const studentInfo = user.student_info || user;
        const fullName = `${studentInfo.student_lastName || ""} ${studentInfo.student_givenName || ""}`.trim();
        candidateName = normalize(studentInfo.name || fullName || candidateName);
        email = normalize(studentInfo.account_name || studentInfo.student_email || studentInfo.email || email);
      } catch (error) {
        console.error("Unable to load candidate identity before exam entry", error);
      }
      return { candidateName, email };
    },
    buildListEntryState(item) {
      const examInfo = item && item.exam_info ? item.exam_info : null;
      const scheduleStatus = examInfo && examInfo.status ? examInfo.status.status : "";
      if (!examInfo) {
        return { code: "unavailable", label: "Unavailable", detail: "Exam data missing", action: "none" };
      }
      if (scheduleStatus === "还未开始") {
        return { code: "countdown", label: "Test Countdown", detail: "", action: "none" };
      }

      if (this.getExamMode(item) === "individual" && item.individual_exam) {
        const state = item.individual_exam;
        if (this.isIndividualFinalizing(item)) {
          return { code: "finalizing", label: "Submitting...", detail: "Please wait", action: "none" };
        }
        if (state.status === "expired" || (state.status === "in_progress" && state.entry_allowed === false)) {
          return { code: "personal-expired", label: "Window Expired", detail: "24-hour window ended", action: "personal-expired" };
        }
        if (state.status === "completed") {
          return { code: "completed", label: "Completed", detail: "Submission received", action: "completed" };
        }
        if (scheduleStatus === "已结束" && state.status === "not_started") {
          return { code: "closed", label: "Closed for Entry", detail: "Entry window ended", action: "closed" };
        }
        if (state.status === "in_progress") {
          const sectionCount = Number(state.section_count);
          const currentIndex = Number(state.current_section_index);
          const stageNumber = Number.isFinite(currentIndex) ? currentIndex + 1 : 1;
          const detail = Number.isFinite(sectionCount) && sectionCount > 0
            ? `Stage ${Math.min(stageNumber, sectionCount)} of ${sectionCount}`
            : "Personal exam in progress";
          const sections = Array.isArray(state.sections) ? state.sections : [];
          const section = sections[Number.isFinite(currentIndex) ? currentIndex : 0] || {};
          return {
            code: section.status === "in_progress" ? "resume" : "continue",
            label: section.status === "in_progress" ? "Resume Exam" : "Continue Exam",
            detail,
            action: "enter",
          };
        }
        if (state.status === "not_started" && scheduleStatus === "进行中") {
          return { code: "open", label: "Test Entry", detail: "Start Stage 1", action: "enter" };
        }
      }

      if (examInfo.status.complete_status === true) {
        return { code: "completed", label: "Completed", detail: "Submission received", action: "completed" };
      }
      if (scheduleStatus === "进行中") {
        return { code: "open", label: "Test Entry", detail: "", action: "enter" };
      }
      if (scheduleStatus === "已结束") {
        return { code: "closed", label: "Closed for Entry", detail: "Entry window ended", action: "closed" };
      }
      return { code: "unavailable", label: "Unavailable", detail: "Contact support", action: "none" };
    },
    handleListEntryAction(item) {
      const state = item && item.entry_state ? item.entry_state : null;
      if (!state || state.action === "none") return;
      if (state.action === "enter") {
        this.goExam(item);
      } else if (state.action === "completed") {
        this.showTip(1);
      } else if (state.action === "closed") {
        this.showTip(2);
      } else if (state.action === "personal-expired") {
        this.showTip(3);
      }
    },
    getEntryStateColor(item) {
      const code = item && item.entry_state ? item.entry_state.code : "";
      if (code === "completed") return "#207A52";
      if (code === "personal-expired") return "#A9362B";
      if (code === "finalizing") return "#765A20";
      return this.getEventColor(item.event_name);
    },
    getPersonalWindowEnd(sign, individualExam) {
      if (individualExam && typeof individualExam === "object") {
        const individualEnd = Number(individualExam.window_end_time);
        if (Number.isFinite(individualEnd) && individualEnd > 0) return individualEnd;
        const signIndividualEnd = sign && Number(sign.individual_window_end_time);
        return Number.isFinite(signIndividualEnd) && signIndividualEnd > 0 ? signIndividualEnd : 0;
      }
      if (!sign || typeof sign !== "object") return 0;
      const repairEnd = sign.repair_sign && Number(sign.repair_sign.repair_end_time);
      if (Number.isFinite(repairEnd) && repairEnd > 0) return repairEnd;
      const end = Number(sign.end_time);
      return Number.isFinite(end) && end > 0 ? end : 0;
    },
    getExamMode(item) {
      const mode = item && item.exam_mode ? item.exam_mode : 'relay';
      return String(mode).toLowerCase() === 'individual' ? 'individual' : 'relay';
    },
    isIndividualFinalizing(item) {
      if (this.getExamMode(item) !== 'individual' || !item.individual_exam) {
        return false;
      }
      const finalization = item.individual_exam.finalization || {};
      return ['completed', 'expired'].indexOf(item.individual_exam.status) !== -1
        && finalization.status !== 'success';
    },
    async doCheck(template_id, timeStr, event_type, test_event, exam_mode, item, clockResult, diagnostics) {
      var student_id = getUserId();
      try {
        const res = await checkIsUploadTest(template_id, student_id);
        var result = res.data;
        if (result) {
          this.showEntryBlocked(item, "ALREADY_SUBMITTED", clockResult, diagnostics);
        } else {
          const bindingResponse = await claimExamIpBinding(
            student_id,
            template_id,
            item.project_code || getProjectCode()
          );
          const bindingResult = bindingResponse && bindingResponse.data
            ? bindingResponse.data
            : null;
          if (!bindingResult || bindingResult.code !== 0) {
            this.showEntryBlocked(
              item,
              bindingResult && bindingResult.code === -12 ? "IP_CONFLICT" : "IP_CHECK_FAILED",
              clockResult,
              diagnostics,
              bindingResult && bindingResult.msg
            );
            return;
          }

          const continueToExam = async () => {
            const examProjectCode = resolveAndSetExamProjectCode(
              item.project_code || getProjectCode()
            );
            setTestEvent(test_event);

            try {
              const policy = await this.loadProctoringPolicy(examProjectCode);
              this.closeEntryLoading();
              if (policy.screen && !policy.camera) {
                // Multimedia proctoring is off: skip the camera/microphone
                // preparation page; the exam page still requires screen sharing.
                if (exam_mode === 'relay') {
                  this.$router.push({
                    path: "/waiting-room",
                    query: {
                      template_id: template_id,
                      exam_name: test_event,
                      project_code: examProjectCode,
                    },
                  });
                } else {
                  this.$router.push({
                    path: '/exam',
                    query: {
                      template_id: template_id,
                      invigilateStatus: false,
                      proctor_scope: 'screen',
                      exam_mode: 'individual',
                      project_code: examProjectCode,
                    },
                  });
                }
              } else if (policy.camera) {
                this.$router.push({
                  path: "/ready/exam",
                  query: {
                    template_id: template_id,
                    start_time: timeStr,
                    end_time: item.exam_info.exam_end_time * 1000,
                    event_type: event_type,
                    exam_mode: exam_mode,
                    exam_name: test_event,
                    project_code: examProjectCode,
                  },
                });
              } else if (exam_mode === 'relay') {
                this.$router.push({
                  path: "/waiting-room",
                  query: {
                    template_id: template_id,
                    exam_name: test_event,
                    project_code: examProjectCode,
                  },
                });
              } else {
                this.$router.push({
                  path: '/exam',
                  query: {
                    template_id: template_id,
                    invigilateStatus: true,
                    exam_mode: 'individual',
                    project_code: examProjectCode,
                  },
                });
              }
            } catch (error) {
              console.error("Unable to load exam proctoring requirements", error);
              this.showEntryBlocked(item, "ENTRY_CHECK_FAILED", clockResult, diagnostics);
            }
          };

          if (exam_mode === 'individual') {
            await continueToExam();
            return;
          }

          // Relay mode still requires a valid team before entering its waiting room.
          try {
            const teamRes = await getRelayTeamMembers(
              student_id,
              template_id,
              item.project_code || getProjectCode()
            );
            if (teamRes.data.code !== 0 || (teamRes.data.data.members || []).length === 0) {
              this.closeEntryLoading();
              this.noTeamContext = this.buildNoTeamContext(item);
              this.noTeamTemplateName = item.template_id || "";
              this.noTeamDialogVisible = true;
              return;
            }
            await continueToExam();
          } catch (error) {
            this.closeEntryLoading();
            this.noTeamContext = this.buildNoTeamContext(item);
            this.noTeamTemplateName = item.template_id || "";
            this.noTeamDialogVisible = true;
          }
        }
      } catch (error) {
        console.error("Exam entry check failed", error);
        this.showEntryBlocked(item, "ENTRY_CHECK_FAILED", clockResult, diagnostics);
      }
    },
    async loadProctoringPolicy(projectCode) {
      try {
        const res = await getExamProctoringPolicy(projectCode, getUserId());
        const result = res && res.data;
        if (result && result.code === 0 && result.data) {
          return result.data;
        }
      } catch (error) {
        console.warn("Proctoring policy unavailable, using legacy check", error);
      }
      const legacy = await checkUserInvigilate(projectCode, getUserId());
      const proctoring = legacy.data == true;
      return { proctoring, camera: proctoring, microphone: proctoring, screen: proctoring };
    },
    closeEntryLoading() {
      if (this.entryLoading) {
        this.entryLoading.close();
        this.entryLoading = null;
      }
    },
    isMockTest(item) {
      // getExamRooms returns the raw exam_time_arr type ("Mock" / "Formal").
      const examInfo = item && item.exam_info ? item.exam_info : null;
      const examType = String((examInfo && examInfo.exam_type) || "").trim().toLowerCase();
      return examType === "mock" || examType === "mock_test";
    },
    buildNoTeamContext(item) {
      return {
        page: "list",
        reason: "team_not_found",
        project_code: (item && item.project_code) || this.project_code || getProjectCode(),
        template_id: (item && item.template_id) || "",
        exam_name: (item && item.event_name) || "",
      };
    },
    formatDiagnosticTime(milliseconds) {
      const value = Number(milliseconds);
      if (!Number.isFinite(value) || value <= 0) return "Not recorded";
      return new Date(value).toISOString().replace("T", " ").replace(".000Z", " UTC");
    },
    showEntryBlocked(item, reason, clockResult, diagnostics, serverMessage) {
      const copy = {
        SERVER_TIME_UNAVAILABLE: [
          "Exam server time unavailable",
          "The system could not verify the authoritative exam time.",
          "Server time check",
          "Check your network connection and try again. Entry remains blocked while server time cannot be verified.",
        ],
        CLOCK_MISMATCH: [
          "Computer clock mismatch",
          "Your computer clock differs too much from the exam server.",
          "Device date and time",
          clockResult ? buildClockErrorMessage(clockResult.clockSkewMs) : "Correct the device clock and try again.",
        ],
        NOT_STARTED: [
          "The test has not started",
          "Entry opens only when the scheduled exam time arrives.",
          "Scheduled opening time",
          "Wait until the opening time shown below, then try again.",
        ],
        ENTRY_CLOSED: [
          "The test is closed for entry",
          "The scheduled entry window has ended.",
          "Scheduled closing time",
          "This exam can no longer be entered from the standard entry window.",
        ],
        TEMPLATE_UNAVAILABLE: [
          "Exam data unavailable",
          "No valid test template is assigned to this exam.",
          "Exam template",
          "Contact support and include the reference shown below.",
        ],
        ALREADY_SUBMITTED: [
          "Exam already submitted",
          "A completed submission already exists for this candidate.",
          "Submission status",
          "Submitted exams are final and cannot be entered again.",
        ],
        PERSONAL_WINDOW_EXPIRED: [
          "Personal exam window expired",
          "Your 24-hour personal exam window has ended.",
          "Personal exam window",
          "The remaining stages are now closed and cannot be reopened.",
        ],
        IP_CONFLICT: [
          "IP address already used",
          "This network address is already bound to another candidate for this exam.",
          "One candidate per IP address",
          serverMessage || "Use the candidate's original exam network or contact support if this is unexpected.",
        ],
        IP_CHECK_FAILED: [
          "Network identity could not be verified",
          "The exam server could not confirm the participation IP limit.",
          "IP participation check",
          serverMessage || "Check your network connection and try again.",
        ],
        ENTRY_CHECK_FAILED: [
          "Entry check unavailable",
          "One or more required exam checks could not be completed.",
          "Exam entry verification",
          "Check your connection and try again. Entry is not allowed when a required check is unavailable.",
        ],
      };
      const selected = copy[reason] || copy.ENTRY_CHECK_FAILED;
      const examInfo = item && item.exam_info ? item.exam_info : {};
      const sign = diagnostics && diagnostics.sign ? diagnostics.sign : null;
      const individualExam = this.getExamMode(item) === "individual"
        ? ((diagnostics && diagnostics.individual_exam) || (item && item.individual_exam) || null)
        : null;
      const submission = diagnostics && diagnostics.submission ? diagnostics.submission : null;
      const now = clockResult && clockResult.serverTimeMs ? clockResult.serverTimeMs : Date.now();
      const personalWindowStart = individualExam && individualExam.window_start_time
        ? Number(individualExam.window_start_time)
        : (sign && Number(sign.individual_window_start_time || sign.begin_time));
      const personalWindowEnd = individualExam && individualExam.window_end_time
        ? Number(individualExam.window_end_time)
        : (sign && Number(sign.individual_window_end_time || sign.end_time));
      const personalWindowValue = personalWindowStart || personalWindowEnd
        ? `${this.formatDiagnosticTime(personalWindowStart * 1000)} → ${this.formatDiagnosticTime(personalWindowEnd * 1000)}`
        : "No personal window recorded";
      this.entryDiagnostic = {
        title: selected[0],
        summary: selected[1],
        failureLabel: selected[2],
        failureDetail: selected[3],
        reason,
        rows: [
          { label: "Candidate / exam", value: `${getUserId()} · ${item ? item.event_name : "Unknown exam"}` },
          { label: "Project / template", value: `${item && item.project_code ? item.project_code : getProjectCode()} · ${item && item.template_id ? item.template_id : "Not assigned"}` },
          { label: "Scheduled entry window", value: `${this.formatDiagnosticTime(Number(examInfo.exam_begin_time) * 1000)} → ${this.formatDiagnosticTime(Number(examInfo.exam_end_time) * 1000)}` },
          { label: "Verified server time", value: this.formatDiagnosticTime(now) },
          { label: "Check-in / personal window", value: personalWindowValue },
          { label: "Submission", value: submission ? `${submission.test_status || "Completed"} · ${this.formatDiagnosticTime(Number(submission.submitted_at) * 1000)}` : "No completed submission found" },
        ],
        reference: [
          item && item.project_code ? item.project_code : getProjectCode(),
          item && item.template_id ? item.template_id : "unknown-template",
          getUserId(),
          Math.floor(now / 1000),
        ].join("/"),
      };
      this.closeEntryLoading();
      this.showEntryDiagnostic = true;
    },

    showTip(item){

      if (item == 1){
        this.$alert(
            "Please note that you have already completed this test. No re-entry is allowed.",
            "Tip",
            {
              confirmButtonText: "OK",
              callback: () => {},
            }
          );
      }
      if (item == 2){
        this.$alert(
            "You have missed the entry time for this exam. For further assistance, please contact your instructor.",
            "Test Entry Closed",
            {
              confirmButtonText: "Confirm",
              callback: () => {},
            }
          );
      }
      if (item == 3){
        this.$alert(
            "Your 24-hour personal exam window has ended. The remaining stages are closed and cannot be reopened.",
            "Personal Exam Window Expired",
            {
              confirmButtonText: "OK",
              callback: () => {},
            }
          );
      }


      
    },
    formateTime(data) {
      let item = new Date(data * 1000);
      let month = item.getMonth() + 1;
      return (
        item.getDate() +
        " " +
        this.formatMonth(month) +
        " " +
        item.getFullYear() +
        " " +
        this.formatValue(item.getHours()) +
        ":" +
        this.formatValue(item.getMinutes()) +
        ":" +
        this.formatValue(item.getSeconds()) 
      );
    //   return `${item.getMonth()+1}-${item.getDate()} ${item.getHours()}:${item.getMinutes()>9?item.getMinutes():'0'+item.getMinutes()}`;
    },
    formatMonth(month) {
      switch (month) {
        case 1:
          return "Jan";
        case 2:
          return "Feb";
        case 3:
          return "Mar";
        case 4:
          return "Apr";
        case 5:
          return "May";
        case 6:
          return "Jun";
        case 7:
          return "Jul";
        case 8:
          return "Aug";
        case 9:
          return "Sep";
        case 10:
          return "Oct";
        case 11:
          return "Nov";
        case 12:
          return "Dec";
      }
    },
    formatValue(value) {
      if (value > 9) {
        return value;
      }
      return "0" + value;
    },
    getBannerImage(event_name) {
      let name = this.handleEventName(event_name);
      let available = ['Artithon','Biothon','Chemithon','Econthon','Geothon','Historithon','Mathethon','Mock','Physithon','Psychothon'];
      if (available.indexOf(name) === -1) {
        name = 'Mock';
      }
      return require('../../../assets/banner/' + name + '.png');
    },
    getEventColor(event_name) {
      let name = this.handleEventName(event_name);
      return this.colorMap[name] || '#11448D';
    },
    handleEventName(event) {
      let event_array = event.split(" ");
      return event_array[0];
    },
    handleIndex(index) {
      return (index % 4) + 1;
    },
    getFormatDuringTime(during) {
      var s = Math.floor(during / 1) % 60;
      during = Math.floor(during / 60);
      var i = during % 60;
      during = Math.floor(during / 60);
      var h = during;
      return h + ":" + i + ":" + s;
    },
    handleRestTime(item) {
      const examInfo = item.exam_info;
      let totalTime = examInfo.status.rest_time;
      examInfo.countDownThread = window.setInterval(() => {
        this.$set(examInfo, "countDownTimes", this.getFormatDuringTime(totalTime));
        totalTime--;
        if (totalTime < 0) {
          window.clearInterval(examInfo.countDownThread);
          examInfo.status.status = "进行中";
          this.$set(item, "entry_state", this.buildListEntryState(item));
        }
        // console.log(this.event_rooms)
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.listContainer {
  .listToolbar {
    display: flex;
    justify-content: flex-end;
    width: 84%;
    margin: 16px 0 0 20px;
    .messagesToolbarBtn {
      border-color: #072d76;
      color: #072d76;
      font-weight: 600;
      &:hover,
      &:focus {
        color: #11448d;
        border-color: #11448d;
        background: #f0f4ff;
      }
    }
  }
  .emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 20vh;
    .emptyLogo {
      width: 80px;
      opacity: 0.5;
      margin-bottom: 20px;
    }
    .emptyText {
      font-size: 2vh;
      color: #878FB1;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }
  .dl {
    width: 84%;
    display: flex;
    align-items: center;
    font-family: Impact;
    justify-content: center;

    color: #072d76;
    font-size: 50px;
    margin-bottom: 20px;
  }
  .eventItem {
    width: 84%;
    height: 17vh;
    margin-bottom: 4vh;
    position: relative;
    display: flex;
    margin-left: 20px;
    margin-top: 20px;
    .eventImg {
      position: absolute;
      top: 0;
      // z-index: 1;
      height: 100%;
      width: 100%;
      max-width: 100%;
      display: block;
    }
    .left {
      width: 60%;
      overflow: hidden;
      position: relative;
      .itemTitle {
        margin-top: 2vh;
        font-size: 2.4vh;
        font-family: Impact;
        font-weight: 400;
        padding-left: 30px;
        white-space: nowrap;
      }
      .itemName {
        font-size: 5vh;
        font-family: Impact;
        font-weight: 400;
        padding-left: 30px;
        white-space: nowrap;
      }
      .eventTime {
        background: #32b67a;
        height: 2.6vh;
        width: 100%;
        margin-top: 1vh;
        margin-left: 30px;
        color: white;
        font-size: 1.4vh;
        line-height: 2.6vh;
        font-family: Microsoft YaHei;
        font-weight: bold;
        .eventTimeContainer {
          // background-color: red;
          width: 100%;
          margin: 0 auto;
          display: flex;
          .eventTimeItem {
            width: 50%;
            margin-left: 10px;
            text-align: left;
          }
        }
      }
      .mockWarning {
        margin: 0.8vh 30px 0;
        max-width: 46%;
        padding: 0.5vh 10px;
        box-sizing: border-box;
        border: 1px solid #e6a23c;
        border-left: 3px solid #e6a23c;
        border-radius: 4px;
        background: rgba(255, 247, 230, 0.94);
        color: #7a4d0b;
        font-size: 1.25vh;
        line-height: 1.4;
        font-family: Microsoft YaHei;
        font-weight: 600;
      }
      &.has-mock-warning {
        .itemTitle {
          margin-top: 1vh;
        }
        .itemName {
          font-size: 4.2vh;
        }
        .eventTime {
          margin-top: 0.6vh;
        }
        .mockWarning {
          margin-top: 0.5vh;
          padding: 0.4vh 10px;
          font-size: 1.15vh;
        }
      }
    }
    .right {
      width: 38%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .eventStatusContainer {
        width: 18vh;
        height: 50%;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .toContent {
          width: 100%;
          height: 100%;
          border: 0;
          background: transparent;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.45vh;
          text-align: center;
          color: white;
          font-family: Microsoft YaHei;
          font-weight: bold;
          cursor: pointer;
          padding: 1vh 10px;
          line-height: 1.15;
          box-sizing: border-box;
          span {
            font-size: 2vh;
          }
          small {
            display: block;
            max-width: 100%;
            font-size: 1.05vh;
            font-weight: 600;
            line-height: 1.25;
            opacity: 0.88;
          }
          &:focus-visible {
            outline: 3px solid #ffffff;
            outline-offset: -5px;
          }
          &.is-disabled {
            cursor: default;
            opacity: 0.92;
          }
        }
        .outContent {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          .txt {
            margin-top: 0.4vh;
            font-size: 1.4vh;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
          }
          .time {
            background: white;
            width: 80%;
            padding: 0.6vh 4px;
            font-family: Impact;
            font-weight: 400;
            font-size: 3vh;
            text-align: center;
            margin-bottom: 0.4vh;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.list-team-dialog {
  .el-dialog__header { display: none; }
  .el-dialog__body { max-height: 90vh; padding: 0; overflow-y: auto; }
}
.list-team-dialog__header {
  padding: 22px 26px 18px;
  color: #fffaf7;
  background: #9f2f25;
  span { font-size: 11px; font-weight: 700; letter-spacing: 0.12em; }
  h2 { margin: 6px 0 6px; color: inherit; font-size: 22px; line-height: 1.2; }
  p { margin: 0; font-size: 13px; line-height: 1.5; }
}
.list-team-dialog__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px 26px 6px;
}
.list-team-dialog__actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 26px 20px;
}

.exam-identity-confirm.el-message-box {
  width: calc(100% - 32px);
  max-width: 540px;
  border: 1px solid #dce3fd;
  border-radius: 10px;
  font-family: Montserrat-SemiBold, sans-serif;

  .el-message-box__header { padding: 24px 24px 12px; }
  .el-message-box__title { color: #1b213d; font-size: 22px; font-weight: 700; }
  .el-message-box__content { padding: 8px 24px 4px; }
  .el-message-box__status { top: 14px; color: #f18601; }
  .el-message-box__message { padding-left: 34px; }
  .el-message-box__btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    padding: 20px 24px 24px;
    .el-button {
      min-height: 44px;
      margin-left: 0;
      padding: 10px 18px;
      border-radius: 6px;
      white-space: normal;
    }
    .el-button--primary { background: #4468ec; border-color: #4468ec; }
  }
}
.exam-identity-confirm__content { color: #4a526d; font-size: 14px; line-height: 1.6; }
.exam-identity-confirm__intro,
.exam-identity-confirm__statement,
.exam-identity-confirm__help { margin: 0; }
.exam-identity-confirm__details {
  margin: 14px 0;
  padding: 12px 14px;
  border: 1px solid #dce3fd;
  border-radius: 8px;
  background: #f5f7ff;
}
.exam-identity-confirm__row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: 12px;
  align-items: baseline;
  & + & { margin-top: 8px; padding-top: 8px; border-top: 1px solid #e3e8f8; }
}
.exam-identity-confirm__label { color: #6b7390; font-size: 12px; font-weight: 600; text-transform: uppercase; }
.exam-identity-confirm__name { color: #1b213d; font-size: 19px; overflow-wrap: anywhere; }
.exam-identity-confirm__account { color: #273161; overflow-wrap: anywhere; }
.exam-identity-confirm__statement { color: #273161; font-weight: 600; }
.exam-identity-confirm__help { margin-top: 8px; color: #7a4d0b; }

@media (max-width: 520px) {
  .exam-identity-confirm.el-message-box {
    .el-message-box__message { padding-left: 0; }
    .el-message-box__status { display: none; }
    .el-message-box__btns .el-button { width: 100%; }
  }
  .exam-identity-confirm__row { grid-template-columns: 1fr; gap: 2px; }
}
</style>
